exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bee-plugin[data-v-79377232] {\n    height:100vh;\n}\n", ""]);

// exports
